<sc-flex vertical fitHeight stretchContent  class="link-transports" stretchContent>

  <sc-dialog-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.ui.link-transports-dialog.title"></sc-dictionary-label>
  </sc-dialog-title>


  <app-transport-info-panel [carrier]="data.details.carrier" [identifier]="data.details.identifier"
    [driver]="data.details.name" [scope]="data.details.transportScope" [type]="data.details.type">
  </app-transport-info-panel>

  <sc-flex-fitting-content vertical>

    <!-- Auswahl Transport -->
    <ng-container *ngIf="currentPage === 0">
      <sc-padding fitHeight>
        <sc-flex fitHeight vertical stretchContent>
          <sc-title>
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.link-transports-dialog.table-header"></sc-dictionary-label>
          </sc-title>
          <sc-content-spacer vertical></sc-content-spacer>
          <sc-flex-fitting-content vertical>
            <sc-scroll-pane>
              <sc-tmc-table [tableModel]="tableModel" #tmcTableComponent></sc-tmc-table>
            </sc-scroll-pane>
          </sc-flex-fitting-content>
        </sc-flex>
      </sc-padding>
    </ng-container>

    <!-- Auswahl Zeitfenster -->
    <ng-container *ngIf="currentPage === 1">
      <sc-padding fitHeight>
        <sc-title>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.link-transports-dialog.timeframes.title"></sc-dictionary-label>
        </sc-title>
        <form #timeFrameSelectionForm="ngForm">
          <mat-radio-group aria-label="Select an option" [(ngModel)]="selectedTimeFrame" class="timeframe-list"
            name="timeframes">
            <mat-radio-button [value]="-1" class="margin-bottom">
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.link-transports-dialog.timeframes.no-timeframe"></sc-dictionary-label>
            </mat-radio-button>
            <mat-radio-button class="margin-bottom" [value]="tf.timeframe" *ngFor="let tf of availableTimeframes">
              {{tf.timeframeDate}}</mat-radio-button>
          </mat-radio-group>
        </form>
      </sc-padding>
    </ng-container>

    <div class="messages">
      <app-service-response [responseMessages]="responseMessages"></app-service-response>
    </div>
  </sc-flex-fitting-content>


  <sc-actionbar>
    <sc-back-button (click)="showTransportSelection()" *ngIf="currentPage === 1" dictionaryKey="tmc-yard.common.action.previous"></sc-back-button>
    <sc-content-spacer grow></sc-content-spacer>
    <sc-cancel-button (click)="closeDialog()" class="cancel-button"
    [disabled]="isCloseDialogDisabled()" dictionaryKey="tmc-yard.common.action.cancel"></sc-cancel-button>
    <sc-content-spacer></sc-content-spacer>
    <sc-forward-button primary (click)="showTimeFrameSelection()" [disabled]="isShowTimeFrameSelection()" dictionaryKey="tmc-yard.common.action.next"
    *ngIf="currentPage === 0 && data.details.type !== 'VEHICLE'" dictionaryKey="tmc-yard.common.action.next"></sc-forward-button>
    <sc-button primary (click)="linkTransports()" [disabled]="isLoading || this.selectedTimeFrame == null"
      dictionaryKey="tmc-yard.ui.link-transports-dialog.action.linkTransports"
      *ngIf="currentPage === 1">
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.link-transports-dialog.action.linkTransports"></sc-dictionary-label>
    </sc-button>
    <button mat-flat-button (click)="linkVehicleWithTransport()"
      [disabled]="isLoading || this.selectedTimeFrame == null"
      *ngIf="currentPage === 0 && data.details.type === 'VEHICLE'">
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.link-transports-dialog.action.linkVehicleWithTransport"></sc-dictionary-label>
    </button>
  </sc-actionbar>

</sc-flex>
